import { html } from "@lit-labs/ssr";

import { HomepageBody } from "../homepage-body/server.js";
import { HomepageFooter } from "../homepage-footer/server.js";
import { HomepageHeader } from "../homepage-header/server.js";
import { PageLayout } from "../page-layout/server.js";
import { ServerComponent } from "../server/index.js";

export class Homepage extends ServerComponent {
  /**
   * @param {import("@fred").Context<import("@rari").HomePage>} context
   */
  render(context) {
    return PageLayout.render(
      context,
      html`
        <div id="content" class="homepage homepage--dark">
          ${HomepageHeader.render(context)}
        </div>
        <div class="homepage">
          <mdn-placement-hp-main></mdn-placement-hp-main>
          ${HomepageBody.render(context)}
        </div>
        <div class="homepage homepage--dark">
          ${HomepageFooter.render(context)}
        </div>
      `,
    );
  }
}
